<div class="card-per-filter">
  <mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor" class="example-tree">

  <!-- Nested tree node for all nodes -->
  <mat-nested-tree-node *matTreeNodeDef="let node">
    <li>
      <div class="mat-tree-node">
        <mat-checkbox
          [checked]="getNodeCheckedState(node)"
          [indeterminate]="descendantsPartiallySelected(node)"
          (change)="node.children ? selectParentNode(node, $event) : selectOnecheck(node, $event)"
          class="checklist-leaf-node"
        >
          <span class="checkbox-text-side">{{ node.option[attrLabel] }}</span>
        </mat-checkbox>

        <!-- Toggle button only for nodes with children -->
        <button *ngIf="node.children?.length"
                mat-icon-button
                matTreeNodeToggle
                [attr.aria-label]="'Toggle ' + node.name"
                class="arrow-select">
          <mat-icon class="mat-icon-rtl-mirror">
            {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>
      </div>

      <!-- Children -->
      <div [class.example-tree-invisible]="!tree.isExpanded(node)" role="group" class="ms-3">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </li>
  </mat-nested-tree-node>

</mat-tree>

</div>
